module.exports = __webpack_public_path__ + "img/bg09.9fc9275c.gif";